import { Design, DesignState, getDesignState } from "../../../../core/models/entities/Design";
import { hasUserPendingApprovalStatus } from "../../../../core/models/entities/BaseLogo";
import { Role } from "../../../../core/models/entities/Role";
import { canRejectAndEdit } from "./designRejectAndEdit";

// The design list's "See note" -> Edit (flag
// REACT_APP_DESIGN_REJECTION_NOTE_EDIT_ENABLED; the flag itself is read by
// the screen): true only where the popup's Rejected layout shows Edit to
// this user for this design, so the dialog never offers Edit where the popup
// would not - canRejectAndEdit (rejectAndEditEnabled, not a customer, a
// style; the popup's "fix it myself" gate), the design IS Rejected,
// isEditable not false (the popup's withoutEditIfNotEditable) and no pending
// vote of the user's own (the popup shows Approve instead of Edit then). Only
// a dealer or an admin; the customer and an unknown role never get it. The
// one way the two differ: a rejected design WITHOUT a MUL keeps the popup's
// Edit even without a style or with rejectAndEditEnabled off; the dialog
// hides it there (the editor requires a style) - stricter, never looser.
export function canEditDesignFromRejectionNote(
  design: Design,
  role: Role | undefined
): boolean {
  if (role !== Role.Vendor && role !== Role.Admin) return false;
  if (!canRejectAndEdit(design, false)) return false;
  if (getDesignState(design) !== DesignState.Rejected) return false;
  if (design.isEditable === false) return false;
  return !hasUserPendingApprovalStatus(design.approval, role);
}
